import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React, { useMemo, useCallback } from 'react';
import InlineSocialOutline from '../../../../shared/ui/widgets/inline_social_outline/InlineSocialOutline';
// Fase 5.10: NodeView de Tiptap que re-establece los PROVIDERS (no hooks) para el subárbol del
// widget, que se monta desconectado del árbol de la app. Misma excepción que
// `InlineSocialOutline.jsx` (5.6).
// eslint-disable-next-line no-restricted-imports
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../../../app/queryClient';
// eslint-disable-next-line no-restricted-imports
import { ToastProvider } from '../../../../shared/ui/Toast/ToastProvider';

const InlineSocialOutlineBlockView = ({ node, updateAttributes, extension, deleteNode }) => {
    const { id, docId, spaceId } = node.attrs;
    const resolvedDocId = docId || extension.options.docId;
    const resolvedSpaceId = spaceId || extension.options.spaceId;

    return (
        <NodeViewWrapper className="doc-inline-social-outline-node-wrapper" data-id={id}>
            <div
                className="doc-inline-social-outline-block"
                data-id={id}
                contentEditable={false} suppressContentEditableWarning
            >
                <QueryClientProvider client={queryClient}>
                    <ToastProvider>
                        <InlineSocialOutline
                            blockId={id}
                            docId={resolvedDocId}
                            spaceId={resolvedSpaceId}
                            onDelete={deleteNode}
                        />
                    </ToastProvider>
                </QueryClientProvider>
            </div>
        </NodeViewWrapper>
    );
};

export const InlineSocialOutlineExtension = Node.create({
    name: 'inlineSocialOutline',
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addOptions() {
        return {
            docId: null,
            spaceId: null,
        };
    },

    addAttributes() {
        return {
            id: {
                default: () => `social-outline-${Date.now()}`,
                parseHTML: element => element.getAttribute('data-id') || `social-outline-${Date.now()}`,
                renderHTML: attributes => ({ 'data-id': attributes.id }),
            },
            docId: {
                default: null,
                parseHTML: element => element.getAttribute('data-doc-id') || null,
                renderHTML: attributes => (attributes.docId ? { 'data-doc-id': attributes.docId } : {}),
            },
            spaceId: {
                default: null,
                parseHTML: element => element.getAttribute('data-space-id') || null,
                renderHTML: attributes => (attributes.spaceId ? { 'data-space-id': attributes.spaceId } : {}),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div.doc-inline-social-outline-block',
                getAttrs: element => ({
                    id: element.getAttribute('data-id') || `social-outline-${Date.now()}`,
                    docId: element.getAttribute('data-doc-id') || null,
                    spaceId: element.getAttribute('data-space-id') || null,
                }),
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes({ class: 'doc-inline-social-outline-block', contenteditable: 'false' }, HTMLAttributes),
            ['div', { class: 'body' }, 'Cargando outline...'],
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(InlineSocialOutlineBlockView);
    },
});

export default InlineSocialOutlineExtension;
